import { Col, Row, Typography } from "antd";
import CurrentPackage from "./CurrentPackage";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

const PackageManagementIndex = () => {
  return (
    <>
      <Col xs={24}>
      <Helmet>
                    <title className="capitalize">{"Üyeliğim"}</title>
                  </Helmet>
        <Row gutter={[0, 20]} className="">
          {/* <Col span={24} className="!flex justify-center">
            <PageTitle title="Üyelik Paketleri" />
          </Col> */}

          <Col xs={24} className="">
            <CurrentPackage />
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default PackageManagementIndex;
